import { hasPermission, UserPermission, UserState } from '@app/store/user'
import { isB2BView } from '@app/utils'

export const getUnreadStatusEnabled = (userState: UserState): boolean => {
  const isB2C = !isB2BView()

  const hasEmailAlias = hasPermission(userState)(
    UserPermission.AccountsHasEmailAlias
  )

  return hasEmailAlias || isB2C
}
